import { request } from '@umijs/max';

// 获取全部分类列表（树形）
export async function getGoodCategoryAll(filter?: API.FormValues) {
  return request('/api/admin/goodCategory/all', {
    method: 'POST',
    data: {
      filter: filter || {},
    },
  });
}

// 获取分类详情
export async function getGoodCategoryInfo(values: API.FormValues) {
  return request('/api/admin/goodCategory/info', {
    method: 'POST',
    data: values,
  });
}

// 创建分类
export async function addGoodCategory(values: API.FormValues) {
  return request('/api/admin/goodCategory/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑分类
export async function editGoodCategory(values: API.FormValues) {
  return request('/api/admin/goodCategory/edit', {
    method: 'POST',
    data: values,
  });
}

// 删除分类
export async function removeGoodCategory(values: API.FormValues) {
  return request('/api/admin/goodCategory/remove', {
    method: 'POST',
    data: values,
  });
}
